import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { getIsUnverified } from '../../publicSession/selectors';
import { ArtBrandedDesktopPopup } from '../../ArtBrandedPopup';
import Button from '../../Button';
import VerificationEmailInput from '../../VerificationEmailInput';
import s from './VerificationPopupDesktop.scss';
export const VerificationPopupDesktop = (_param)=>{
    var { actionType, email, resendEmail, onClose } = _param, props = _object_without_properties(_param, [
        "actionType",
        "email",
        "resendEmail",
        "onClose"
    ]);
    const { t } = useTranslation();
    const modalType = actionType ? 'action' : 'welcome';
    const isUnverified = useSelector(getIsUnverified);
    const title = t(`verification.title.${modalType}`, {
        action: t(`verification.action.${actionType}`)
    });
    const tagline = t(`verification.tagline.${modalType}`);
    return /*#__PURE__*/ React.createElement(ArtBrandedDesktopPopup, _object_spread({
        artImageSrc: Url.staticCDNLink('eclipse/sisu/image-11-620625097.jpg'),
        artAuthorUsername: 'AxiomDesign',
        title: title,
        tagline: tagline,
        className: s[`${modalType}-modal`],
        titleClassName: s['title'],
        taglineClassName: s['tagline'],
        contentClassName: s['content'],
        popupProps: {
            isOpen: true
        },
        onClose: onClose
    }, props), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`verification.checkEmail.${modalType}`, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        email: /*#__PURE__*/ React.createElement("span", {
            className: s['email']
        }, email)
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`verification.instructions.${modalType}`)), /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, /*#__PURE__*/ React.createElement(Button, {
        view: "b3",
        height: "medium",
        className: s['button'],
        onClick: ()=>{
            resendEmail();
            onClose && onClose();
        }
    }, t('verification.resend')), !isUnverified && /*#__PURE__*/ React.createElement("div", {
        className: s['change-email']
    }, t('verification.notEmail', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        email: /*#__PURE__*/ React.createElement("span", {
            className: s['email']
        }, email)
    }), /*#__PURE__*/ React.createElement(VerificationEmailInput, {
        className: s['change-email-input']
    }))), isUnverified && /*#__PURE__*/ React.createElement("div", {
        className: s['footer']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "verification.doormatBlurb"
    }, "If you don't recognize this email or no longer have access to it, please contact support at", /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "mailto:accountrecovery@deviantart.com"
    }, "accountrecovery@deviantart.com"), ' ', "or", /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "https://www.deviantartsupport.com/en/article/what-should-i-do-if-ive-lost-access-to-my-account"
    }, "learn more here"), ".")));
};
VerificationPopupDesktop.displayName = 'VerificationPopupDesktop';
export default VerificationPopupDesktop;
